import styled from "styled-components";

export const Wrapper = styled.div`
  font-size: 12px;
  color: var(--primary-red-color);
  margin-top: 5px;
  margin-bottom: 0px;
`;
